<mat-drawer-container class="h-full">
  <mat-drawer disableClose opened mode="side">
    <div class="p-4 border-b border-gray-200">
      <div class="flex items-center gap-3">
        <div
          class="flex items-center justify-center shrink-0 w-10 h-10 rounded-full bg-gray-200"
        >
          <mat-icon class="shrink-0 size-5! text-xl! leading-none!">person</mat-icon>
        </div>
        <div class="flex-auto overflow-hidden">
          <div class="inline-flex max-w-full text-sm font-semibold text-gray-800">
            <span
              class="block truncate"
              [matTooltip]="clientInfo().name"
              matTooltipPosition="after"
              >{{ clientInfo().name }}</span
            >
          </div>
          <div class="text-xs text-gray-500">ID: #{{ clientInfo().idAlias }}</div>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="clientActionsMenu" class="shrink-0">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #clientActionsMenu="matMenu">
          <button *appHasPermission="'client:update'" mat-menu-item (click)="navigateTo('settings')">
            <mat-icon>edit</mat-icon>
            Bewerken
          </button>
          <button *appHasPermission="'client:move'" mat-menu-item (click)="moveClient()">
            <mat-icon>drive_file_move</mat-icon>
            Verplaatsen
          </button>
          <button *appHasPermission="'client:delete'" mat-menu-item (click)="deleteClient()">
            <mat-icon>delete</mat-icon>
            Verwijderen
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      class="text-xs uppercase tracking-widest font-medium pb-2 px-8 before:w-0 before:h-8 before:align-0 before:inline-block"
    >
      <span>Workspace</span>
    </div>
    <nav class="flex flex-col pb-4 mx-4">
      @for (menuItem of menuItems(); track $index) {
        <a
          class="flex items-center gap-2 px-3.5 text-sm rounded-full font-medium h-8 hover:bg-gray-200 hover:text-gray-800 [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
          [routerLink]="menuItem.route"
          routerLinkActive="active"
        >
          <mat-icon class="shrink-0 size-5! text-xl! leading-none!">{{
            menuItem.icon
          }}</mat-icon>

          <span class="flex-auto truncate">{{ menuItem.label }}</span>
        </a>
      }
    </nav>
  </mat-drawer>

  <mat-drawer-content class="bg-gray-100 !flex flex-col !transition-none">
    <div class="flex-auto overflow-auto scrollbar-width-thin">
      <router-outlet />
    </div>
  </mat-drawer-content>
</mat-drawer-container>
